import axios from 'axios';

const UploadService = {
  async uploadImage(image) {
    const formData = new FormData();
    formData.append('content', image);

    const response = await axios.post('/upload/image', formData);

    return response.data;
  },

  async uploadAttachment(attachment) {
    const formData = new FormData();
    formData.append('content', attachment);

    const response = await axios.post('/upload/attachment', formData);

    return response.data;
  },
};

export default UploadService;
